import { render, staticRenderFns } from "./ConsultantLevels.vue?vue&type=template&id=bf035eb6&scoped=true&"
import script from "./ConsultantLevels.vue?vue&type=script&lang=js&"
export * from "./ConsultantLevels.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantLevels.vue?vue&type=style&index=0&id=bf035eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf035eb6",
  null
  
)

export default component.exports